module.exports = "<kendo-dropdownlist\n    [filterable]=\"true\"\n    [data]=\"data\"\n    (filterChange)=\"filterChange($event)\"\n    textField=\"text\"\n    valueField=\"value\"\n    [valuePrimitive]=\"true\"\n    (valueChange)=\"valueChange($event)\"\n></kendo-dropdownlist>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/filters/menu/select/select.component.html
// module id = ./libs/chassis-datatable/src/components/filters/menu/select/select.component.html
// module chunks = main